var prev = document.getElementsByClassName("previous-version");
var i;

for (i = 0; i < prev.length; i++) {
  prev[i].addEventListener("change", function() {
    var linkValue = this.value;
    var link = this.nextElementSibling;
    link.href = linkValue;
  });
}